import * as _ from 'lodash';
import { CompanyBasicInfo } from '../../../../services/company.model';

export class PrenoteHistoryFilters {

  constructor(
    public companies: CompanyBasicInfo[] = [],
  ) {  }

  static areEqual(a: PrenoteHistoryFilters, b: PrenoteHistoryFilters): boolean {
    if (!!a !== !!b) {
      return false;
    }
    if (!a) {
      return true;
    }

    if (!PrenoteHistoryFilters._areEqual(a.companies, b.companies)) {
      return false;
    }

    return true;
  }

  private static _areEqual(a: any[], b: any[]): boolean {
    if (!a) {
      return !b || !b.length;
    }
    if (!b) {
      return !a.length;
    }

    if (a.length !== b.length) {
      return false;
    }

    return _.isEqual(a, b);
  }

  copy(): PrenoteHistoryFilters {
    return new PrenoteHistoryFilters(
      this.companies);
  }

  clone(): PrenoteHistoryFilters {
    const newFilters = _.clone(this);
    return newFilters;
  }

  reset() {
    this.companies = [];
  }
}
